export const GENDER_LIST = ['Mujer', 'Hombre', 'Transgénero', 'Intersexual', 'Queer', 'Sin género', 'Prefiero no decirlo']